import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { HeaderFlags, FooterMode } from '@/store/ui';
import { Routes, doesRouteRequireGroupOrderRestaurant } from '@/router';

@Component({
  name: 'CmgGroupOrderJoin',
  beforeRouteLeave(to, from, next) {
    this.$services.ui.popHeaderState();
    this.$services.ui.popFooterState();
    this.$services.order.setIsGroupOrderParticipant(false);

    if (!doesRouteRequireGroupOrderRestaurant(to)) {
      this.$services.restaurant.selectRestaurant(this.$appStore.state.restaurant.preGroupOrderFlowRestaurant, this.$services.order.isPickingUp());
    }

    next();
  },
})
export default class CmgGroupOrderConfirmation extends Vue {
  hostName = '';

  get dancingAvocadoVideoUrl() {
    return this.$appStore.state.cms.images.dancingAvocado.default;
  }

  async mounted() {
    this.$services.ui.pushHeaderState({ flags: HeaderFlags.LogoVisibleXS | HeaderFlags.Bag });
    this.$services.ui.pushFooterState({ mode: FooterMode.Micro });

    if (!this.$appStore.state.order.pendingGroupOrder) {
      this.$router.push({ name: Routes.Home });
      return;
    }

    this.hostName = this.$appStore.state.order.pendingGroupOrder.order.customerFirstName;
    this.$services.order.setIsGroupOrderParticipant(true);
    this.$services.ui.nextFocus('good-news');
  }
}
